<template>
  <modal name="dialog-base" height="auto" :classes="['v--modal', 'vue-dialog', this.params.class]" :width="width" :pivot-y="0.3" :adaptive="true" :click-to-close="clickToClose" :transition="transition" @before-open="beforeOpened" @before-close="beforeClosed" @opened="$emit('opened', $event)" @closed="$emit('closed', $event)">
    <div class="px-5 py-5">
      <h2 v-if="params.title" class="mb-4 uppercase tracking-wide text-xl" v-html="params.title || ''" />
      <component :is="params.component" v-if="params.component" v-bind="params.props" />
      <div v-else class="text-sm font-normal tracking-wide mt-5" v-html="params.text || ''" />
    </div>
    <div v-if="buttons" class="flex justify-end mt-5 ml-3 mb-3">
      <button v-for="(button, i) in buttons" :key="i" :class="
          button.class ||
            'bg-blue-500 hover:bg-blue-400 font-semibold text-white text-xs px-6 py-1 rounded mr-2'
        " type="button" :style="buttonStyle" @click.stop="click(i, $event)" v-html="button.title">
        {{ button.title }}
      </button>
    </div>
    <div v-else class="vue-dialog-buttons-none" />
  </modal>
</template>
<script>
export default {
  name: "VueJsDialog",
  props: {
    width: {
      type: [Number, String],
      default: 400
    },
    clickToClose: {
      type: Boolean,
      default: true
    },
    transition: {
      type: String,
      default: "fade"
    }
  },
  data() {
    return {
      params: {},
      defaultButtons: [{ title: "CLOSE" }]
    };
  },
  computed: {
    buttons() {
      return this.params.buttons || this.defaultButtons;
    },

    /**
     * Returns FLEX style with correct width for arbitrary number of
     * buttons.
     */
    buttonStyle() {
      return {
        flex: `1 1 ${100 / this.buttons.length}%`
      };
    }
  },
  methods: {
    beforeOpened(event) {
      window.addEventListener("keyup", this.onKeyUp);
      this.params = event.params || {};
      this.$emit("before-opened", event);
    },
    beforeClosed(event) {
      window.removeEventListener("keyup", this.onKeyUp);
      this.params = {};
      this.$emit("before-closed", event);
    },
    click(i, event, source = "click") {
      const button = this.buttons[i];
      if (button && typeof button.handler === "function") {
        button.handler(i, event, { source });
      } else {
        this.$modal.hide("dialog-base");
      }
    },
    onKeyUp(event) {
      if (event.which === 13 && this.buttons.length > 0) {
        const buttonIndex =
          this.buttons.length === 1
            ? 0
            : this.buttons.findIndex(button => button.default);
        if (buttonIndex !== -1) {
          this.click(buttonIndex, event, "keypress");
        }
      }
    }
  }
};
</script>
